
/**
 * Get a cookie value by name
 */
export const getCookieValue = (name: string): string | undefined => {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  if (match) return match[2];
  return undefined;
};

/**
 * Set a cookie with the given name and value
 */
export const setCookie = (
  name: string, 
  value: string, 
  days: number = 30, 
  path: string = '/'
): void => {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = date.toUTCString();
  document.cookie = `${name}=${value}; expires=${expires}; path=${path}; SameSite=Lax`;
};

/**
 * Delete a cookie by name
 */
export const deleteCookie = (name: string, path: string = '/'): void => {
  document.cookie = `${name}=; path=${path}; expires=Thu, 01 Jan 1970 00:00:01 GMT`;
};
